import http from '@/utils/http'
// import convert from '@/utils/model-convert'
// import { FormArgument } from '@/models/ec-setting'

const EC_FIELD_URL = '/rest/es/fieldmapping/getByUser'
const EC_FIELD_SELECT = '/rest/es/crmstaticfield/listByCrmCode'
const POST_EC_FIELD_URL = '/rest/es/fieldmapping/post'
const UPDATEEC_FIELD_URL = '/rest/es/fieldmapping/updateFieldMappingAndSource'
const DISTRIBUTE_RULE_URL = '/rest/es/fieldmapping/listChannelSourceDistributeRule' // 根据用户获取来源分配规则列表
const POST_EC_FIELD_RULE_URL = '/rest/es/fieldmapping/postChannelSourceDistributeRule' // 新增修改来源分配规则

export default {
  getEcField ({crmCode}, cb) {
    http.get(EC_FIELD_URL, {params: {crmCode}}).then(response => cb(response)).catch(trace => cb(trace.response))
  },
  getDistributRule ({crmCode}, cb) {
    http.get(DISTRIBUTE_RULE_URL, {params: {crmCode}}).then(response => cb(response)).catch(trace => cb(trace.response))
  },
  getEcFieldSelect ({crmCode}, cb) {
    http.get(EC_FIELD_SELECT, {params: {crmCode}}).then(response => cb(response)).catch(trace => cb(trace.response))
  },
  saveEcField (form, cb) {
    let postData = JSON.stringify(form)
    http.post(POST_EC_FIELD_URL, postData, {
      headers: {
        'Content-Type': 'application/json'
      }
    }).then(response => cb(response)).catch(trace => cb(trace.response))
  },
  saveEcRuleField (form, cb) {
    let postData = JSON.stringify(form)
    http.post(POST_EC_FIELD_RULE_URL, postData, {
      headers: {
        'Content-Type': 'application/json'
      }
    }).then(response => cb(response)).catch(trace => cb(trace.response))
  },
  UpdateEcField ({crmCode}, cb) {
    http.get(UPDATEEC_FIELD_URL, {params: {crmCode}}).then(response => cb(response)).catch(trace => cb(trace.response))
  }
}



// WEBPACK FOOTER //
// ./src/api/client/ec-origin.js